import { BaseEntity } from '../base/base.entity';
import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';

export class TemplatesService extends BaseService<string> {
 
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'emails');
    }
}


// WEBPACK FOOTER //
// ./src/app/services/templates.service.ts